<template>
  <div id="exchangeLogRoot">
    <div id="exchangeLogContainer">
      <div id="elTitleDiv">
        <div id="elTitleParent">提现记录</div>
        <div id="elBackImgParent">
          <img id="elBackImg" src="~assets/img//rebate-center/close_red.png" @click="hideExchangeLogPage()"/>
        </div>
      </div>
      <div id="elMessageTagParent">
        <div id="elTime">提现时间</div>
        <div id="elMoney">提现金额</div>
      </div>
      <div id="elLogContainer">
        <span v-for="record in logRecords">
          <ExchangeRecordItem v-bind:time="record['datetime']" v-bind:money="record['amount']"/>
        </span>
      </div>
    </div>
  </div>
 </template>
 
 <script>
  import ExchangeRecordItem from './ExchangeRecordItem.vue';
  export default {
    props:{
      logRecords:{type: Array}
    },  
    data () {
      return {
        //  logRecords:[{"time":"2022-10-10 10:10:59","money":"100"},{"time":"2022-10-11","money":"101"},{"time":"2022-10-12","money":"102"},{"time":"2022-10-13","money":"103"},{"time":"2022-10-14","money":"104"},{"time":"2022-10-15","money":"105"},{"time":"2022-10-16","money":"106"},{"time":"2022-10-17","money":"107"},{"time":"2022-10-18","money":"108"},{"time":"2022-10-19","money":"109"}]
      }
    },
    components: {
      ExchangeRecordItem,

    },
    methods:{
      // 隐藏兑换记录页面
      hideExchangeLogPage(){
        this.$emit("setExchangeLogClose")
      }
    },
  }
 </script>
 
 <style>
#exchangeLogRoot{
    /* display: none; */
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(51,51,51,0.5);
    z-index: 233;
  }
  #exchangeLogContainer{
    width: 300px;
    height: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 255;
    border-radius: 10px 10px 10px 10px;
  }

  #elTitleDiv{
    margin-top: 5px;
    width: 100%;
    height: 30px;
    display: inline-block;
    text-align: center;
  }

  #elBackImgParent{
    display: inline-block;
    float: right;
    height: 30px;
    width: 30px;
    margin-right: 10px;
  }
   
  #elBackImg{
    height: 100%;
    width: 100%;
  }
   
  #elTitleParent{
    margin-left: 40px;/*这里的值是关闭按钮有30px，按钮靠右有10px，所以相加=40px*/
    height: 100%;
    justify-content: center; /*水平居中*/
    align-items: Center; /*垂直居中*/
    position: relative;
    display: inline-block;
    line-height: 30px;
    text-align: center;
    font-weight: bold;
    font-size: x-large;
  }

  #elMessageTagParent{
    display: flex;
    margin-top: 5px;
  }
  #elTime, #elMoney{
    flex: 1;
    display: flex;
    justify-content: center; /*水平居中*/
    align-items: Center; /*垂直居中*/
    font-size: larger;
    font-weight: bold;
    color: red;
  }

  #elLogContainer{
    width: 100%;
    height: 78%;
    overflow-y:auto;
  }

 </style>


// WEBPACK FOOTER //
// src/views/RebateView/ExchangeLog/ExchangeLog.vue